/**
 * Centralised Cesium resolver. Tries the bundler import first (matches what
 * MISceneView uses) and falls back to `globalThis.Cesium` so the helper works
 * in both build environments and ad-hoc browser globals.
 */
let _cesium: any = null;
try { _cesium = require('cesium'); } catch {}
if (!_cesium) {
  try { _cesium = (globalThis as any).Cesium ?? null; } catch { _cesium = null; }
}

export function getCesium(): any { return _cesium; }
export function setCesium(c: any): void { _cesium = c; }
